<template>
<div class="chapter">
<div class="inner_page">
<p class="chapnum">Foreword</p>
<p class="chaptit1">LOOKING FORWARD: “SUBTLY DIFFERENT; TALLER, MAYBE”</p>
<p class="noindent">I’m a shopper. I’ve always been a shopper. Some people get their thrills parachuting down to the ground, some climbing up to the clouds. Not me. I go in. I go in to shop.</p>
<p class="indent">There’s something special that happens in a department store like Auerbach’s. First of all, it’s the people, lots of people, building on or reinventing their personae. Spray by spray, shoe by shoe, a new shirt here, a pair of trousers there. And they seem so happy with their new selves. The salespeople, all experts in their particular field, know exactly what is needed for a successful makeover. Their help is invaluable as they put together perfectly orchestrated symphonies of ensembles.</p>
<p class="indent">I go in feeling OK but somewhat shabby. My clothes are not worn out but tired. They’ve worked hard and are no longer interested in their job. I think they would prefer to be hung up and left alone for a while. Maybe it’s me; maybe they have given me all they can and would prefer working for somebody else, somebody more exciting perhaps.</p>
<p class="indent">The dapper gentleman in the sport coat department looks my way and smiles. Electricity buzzes around me. I’ve found the specialist for my individual malady. I inhale the rich aroma of fine imported wools as I approach the salesman. He has a look of confidence, an air of knowing as he nods ever so slightly. We shake hands, and I realize these are the hands that will be responsible for my transformation. With a neurosurgeon’s precision, he will lift me from my funk and put a stride back in my step.</p>
<p class="indent">As the metamorphosis approaches its completion, I look in the mirror and see myself, not unlike the other happy shoppers. Yes, it’s me, but subtly different. I think taller, maybe. I’m ready to go for that promotion, ask out that pretty blonde, walk as if I know where I’m going. I’m on my way.</p>
<p class="indent">I really must do this more often.</p>
<p class="right">Michael Hallet,<br/>former retailer/owner, Domus, SLC<br/>Domus Isle, Bar Harbor, Maine<sup><span href="#/Notes#FN1" id="F1" title="Link target outside of Sample">1</span></sup></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?6203b98e